import * as React from 'react';

import EmailItem from 'af-components/EditableOrganizationEmailPill/EmailItem';

import type { EmailContactFM } from './formModel';

interface EmailContact {
	id: number;
	email: string;
}

interface OwnProps {
	formKey: string;
	emails: EmailContact[];
	deleteEmailContact: (id: number) => Promise<void>;
	updateEmailContact: (id: number, form: EmailContactFM) => Promise<void>;
}

type Props = OwnProps;

const EmailPillList: React.FC<Props> = (props) => {

	const {
		emails,
		formKey,
		deleteEmailContact,
		updateEmailContact,
	} = props;

	const [emailEditId, setEmailEditId] = React.useState<Nullable<number>>(null);

	const selectEmailForEdit = React.useCallback((_id: number) => {
		setEmailEditId(_id);
	}, []);

	const deselectEmailForEdit = React.useCallback(() => {
		setEmailEditId(null);
	}, []);

	return (
		<>
			{
				emails.map((_email) => {
					return (
						<EmailItem
							deleteEmailContact={deleteEmailContact}
							deselectEmailForEdit={deselectEmailForEdit}
							editingId={emailEditId}
							emailContact={_email}
							formKey={getDynamicFormKey(formKey, _email.id)}
							key={_email.id}
							selectEmailForEdit={selectEmailForEdit}
							updateEmailContact={updateEmailContact}
						/>
					);
				})
			}
		</>
	);

	function getDynamicFormKey(_formKey: string, id: number) {
		return `${_formKey}${id}`;
	}
};

export default React.memo(EmailPillList);
